import React from 'react';
import imgJdd from "../assets/jdd.webp"
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { TbQuote, TbCalendar, TbBook } from 'react-icons/tb';

const Jdd = () => {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      
      <div className='bg-gray-50 min-h-screen'>
        {/* Encabezado Principal */}
        <header className='pt-16 pb-12 px-4'>
          <h1 className="text-4xl md:text-6xl text-center font-black tracking-tighter text-slate-900">
            BIOGRAFÍA
          </h1>
          <div className='w-20 h-1.5 bg-blue-600 mx-auto mt-4 rounded-full'></div>
        </header>

        <main className='max-w-5xl mx-auto px-4 pb-20'>
          <div className='bg-white shadow-2xl rounded-[2.5rem] overflow-hidden border border-gray-100'>
            
            {/* Sección de Perfil (Hero de la Biografía) */}
            <div className='grid md:grid-cols-12 gap-0 border-b border-gray-50'>
              <div className='md:col-span-5 bg-slate-50 p-8 md:p-12 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-gray-100'>
                <div className='relative group'>
                  <div className='absolute -inset-1 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000'></div>
                  <img 
                    className='relative w-48 md:w-64 rounded-2xl shadow-2xl transform transition duration-500 hover:scale-[1.02]' 
                    src={imgJdd} 
                    alt='Javier Duque Duque' 
                  />
                </div>
                <div className='mt-8 text-center'>
                  <div className='flex items-center justify-center gap-2 text-blue-600 mb-2'>
                    <TbCalendar size={20} />
                    <span className='text-sm font-bold tracking-widest uppercase'>Vida y Obra</span>
                  </div>
                  <p className='text-slate-500 text-sm font-medium'>
                    Aránzazu 2 de Julio de 1935 <br /> Manizales 5 de Marzo de 2016
                  </p>
                </div>
              </div>

              <div className='md:col-span-7 p-8 md:p-12 flex flex-col justify-center'>
                <TbQuote className='text-blue-100 text-6xl mb-4' />
                <h2 className='text-3xl md:text-5xl font-extrabold text-slate-900 mb-4 leading-tight'>
                  Javier Duque Duque
                </h2>
                <p className='text-xl text-blue-700 font-light italic leading-relaxed'>
                  "más que un hombre, un educador que dejó huellas indelebles en las comunidades de Manizales y Barranquilla."
                </p>
              </div>
            </div>

            {/* Cuerpo del Texto */}
            <div className='p-8 md:p-16 space-y-8 text-slate-700 text-lg leading-relaxed font-light'>
              
              <div className='drop-cap'>
                <p>
                  La vida de un educador de convicción, inició con su formación académica y humana desde su hogar paterno conformado por Juan José y 
                  Carmen Emilia, continúa su educación internado en los seminarios de Pasto y Popayán de la orden de los Hermanos Menores Capuchinos 
                  de San Francisco de Asís, donde se profundizó su vocación religiosa, recibida de sus padres. Se gradúa en Teología y Pedagogía, 
                  para regresar a finales de los años 50 a su natal Aránzazu, municipio del norte del Departamento de Caldas, para iniciar su labor 
                   educativa en las poblaciones de San Félix y Aránzazu. En 1966 se traslada a Manizales, donde además fue director de la Escuela Restrepo 
                  Maya, profesor y coordinador académico del Instituto Universitario.
                </p>
              </div>

              <div className='bg-blue-50/50 p-8 rounded-[2rem] border-l-4 border-blue-600'>
                <p>
                  En 1976 llega a Barranquilla, se vincula a la labor educativa de los Hermanos Cristianos de La Salle, dedicándose en tiempo completo 
                  al Colegio Biffi La Salle con su labor de docente, que complementó como formador de jóvenes y orientador de familias, por donde más 
                  de 26 años y hasta el año 2002, dejó huellas indelebles. Quienes lo conocimos, sabemos de su labor, donde resaltó el respeto a los demás, 
                  entrega y dedicación a la familia, responsabilidad y compromiso al trabajo, orientación religiosa con principios cristianos de fe, 
                  esperanza, perdón, amor al prójimo, respeto al otro, y todo lo creado por un ser superior, Dios al que siempre le ofreció sumisión con 
                  devoción a Cristo, la Virgen María y la Sagrada Familia.
                </p>
              </div>

              <p>
                En el año 2006 regresa a Manizales donde se reincorpora a la comunidad donde dio sus primeros aportes en pos de la educación, la 
                juventud y la familia. Concentra sus esfuerzos y principios de vida de apoyo a los demás, en los círculos donde se desenvuelve, 
                continuando su misión de referente y orientador de procesos y acciones en pos del bienestar de todos. Para Javier Duque Duque, 
                nunca existió una justificación para faltar a la palabra, el actuar recto, respeto a las instituciones que lo acogieron, el compromiso, 
                la entrega de toda su energía en las labores que desarrolló, fue su lámpara guia, la ética, la moral y las buenas costumbres su cada día.
              </p>

              <div className='pt-8 border-t border-gray-100'>
                <div className='flex items-center gap-3 mb-4'>
                  <div className='bg-blue-600 p-2 rounded-lg text-white'>
                    <TbBook size={24} />
                  </div>
                  <h3 className='text-2xl font-bold text-slate-900'>Legado Familiar</h3>
                </div>
                <p>
                  La familia de Javier Duque Duque está conformada por más de 52 años con su esposa Inés Alzate, sus cuatro hijos: José Jesús, Javier 
                  Humberto, Juan Gabriel, Gloria Ines; los nietos Juan Javier, Daniela María, Santiago, Jose G, David Eduardo, Mariana, Juan Gabriel, 
                  Juan David, quienes son testigos de una vida ejemplar de familia, trabajo, dedicación y amor.
                </p>
              </div>

            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Jdd;